import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';

const importantSteps = Loadable(() => import('../../containers/web/importantSteps'));
export default MapTo('vcg/components/soe-home/react/importantSteps')(importantSteps);
